export default "__VITE_ASSET__DNqIiZkW__"